import React from 'react';
import PeopleIcon from '@mui/icons-material/PeopleAltOutlined';
import { classNames } from '../../../../utils/common/styling.js';
import { styles } from './Profile.styles.js';
import { checkIsDefined } from '../../../../features/Common/modules/DataTypes/utils/nanNullUndef.js';

var Profile = function (_a) {
    var participants = _a.participants, photo = _a.photo, username = _a.username, onClickPhoto = _a.onClickPhoto, className = _a.className, profilePicWrapperClassName = _a.profilePicWrapperClassName, profilePicClassName = _a.profilePicClassName, contentClassName = _a.contentClassName, usernameClassName = _a.usernameClassName, participantsClassName = _a.participantsClassName;
    return (React.createElement("div", { className: classNames(styles.root, className) },
        React.createElement("div", { className: classNames(styles.profilePicWrapper, profilePicWrapperClassName), onClick: onClickPhoto },
            React.createElement("img", { src: photo, alt: "", className: classNames(styles.profilePic, profilePicClassName) })),
        React.createElement("div", { className: classNames(styles.content, contentClassName) },
            React.createElement("h1", { className: classNames(styles.title, usernameClassName) }, username),
            checkIsDefined(participants) && (React.createElement("div", { className: classNames(styles.participants, participantsClassName) },
                React.createElement(PeopleIcon, null),
                participants)))));
};

export { Profile as default };
//# sourceMappingURL=Profile.js.map
